import React from 'react'
import Grid from '@mui/material/Grid';
import { Container } from '@mui/material';
import { Link } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import LogoWhite from "../../assets/images/NXLogo.png";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Icon1 from '../../assets/images/footer/3.png';
import Icon11 from '../../assets/images/footer/3-3.png';
import Icon2 from '../../assets/images/footer/2.png';
import Icon22 from '../../assets/images/footer/2-2.png';
import { FaInstagram, FaDiscord, FaYoutube, FaTiktok } from 'react-icons/fa';
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { useTheme } from "../../context/ThemeContext";

export default function Footer() {
    const { theme } = useTheme();



    return (
        <section className='top-home-footer-section'>
            <Container maxWidth="xl" className='top-home-footer-section-1'>
                <Grid container
                    spacing={3}
                    sx={{
                        alignItems: "center"
                    }}
                >
                    <Grid item xs={12} sm={12} md={4} lg={3}>
                        <Link to="/" className='footer-brand'>
                            <LazyLoadImage
                                src={LogoWhite}
                                alt='store'
                                style={{ display: 'block', marginBottom: "20px" }}
                            />
                        </Link>
                        <div className="social-menu-new-footer">
                            <ul className='p-0 d-flex flex-row'>
                                <li><Link to="https://www.facebook.com/share/1AHv7Ny6Mf/" target="blank" rel="noopener noreferrer"><FaFacebookF className='fab' /></Link></li>
                                <li><Link to="https://www.instagram.com/nvxo_official?igsh=dGkwcThhaTRwd3Y=" target="blank" rel="noopener noreferrer"><FaInstagram className='fab' /></Link></li>
                                <li><Link to="https://youtube.com/@nvxoofficial?si=BWbfmlxcWDIvIyGm" target="blank" rel="noopener noreferrer"><FaYoutube className='fab' /></Link></li>
                                <li><Link to="https://www.tiktok.com/@nvxoecosystem" target="blank" rel="noopener noreferrer"><FaTiktok className='fab' /></Link></li>
                            </ul>
                            <ul className='p-0'>
                                <li><Link to="https://x.com/NVXOofficial" target="blank" rel="noopener noreferrer"><FaXTwitter className='fab' /></Link></li>
                                <li><Link to="https://discord.com/invite/GSkPd2Ve" target="blank" rel="noopener noreferrer"><FaDiscord className='fab' /></Link></li>
                            </ul>
                        </div>
                    </Grid>
                    <Grid item xs={7} sm={7} md={2} lg={3}>
                        <Stack
                            direction="column"
                            useFlexGap
                            sx={{ flexWrap: 'wrap' }}
                        >
                            <Link to="/about">About</Link>
                            <Link to="/attributions">Attributions</Link>
                            <Link to="/cookie-policy">Cookies</Link>
                        </Stack>
                    </Grid>
                    <Grid item xs={7} sm={7} md={2} lg={3}>
                        <Stack
                            direction="column"
                            useFlexGap
                            sx={{ flexWrap: 'wrap' }}
                        >
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            <Link to="/terms">Terms of Use</Link>
                            <Link to="/contact-us">Contact Us</Link>
                            {/* <Link to="">LicenseAggrement</Link> */}
                        </Stack>
                    </Grid>

                    <Grid item xs={7} sm={7} md={4} lg={3}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            <Link to="https://apps.apple.com/us/app/nvxo-wallet-crypto-btc/id6741467282" target='_blank'>
                                <LazyLoadImage
                                    src={theme == "light" ? Icon1 : Icon11}
                                    alt='Appstore'
                                    className='foot-logo'
                                />
                            </Link>

                            <Link to="https://play.google.com/store/apps/details?id=com.nvwallet.wallet" target='_blank'>
                                <LazyLoadImage
                                    src={theme == "light" ? Icon2 : Icon22}
                                    alt='Playstore'
                                    className='foot-logo'
                                />
                            </Link>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </section>
    )
}
